import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const CdwObjectsFormWrapper = styled.div`
  display: block;
  width: 100%;
  height: 400px;
  overflow-y: auto;
`;

export const CdwObjectsFormHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  margin-bottom: 8px;
`;

export const CdwObjectRowItem = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 8px;
`;

export const HeaderTitleItem = styled(CdwObjectRowItem)`
  justify-content: center;
  color: ${theme.colors.secondary900};
`;

export const HeaderSearchItem = styled(CdwObjectRowItem)`
  justify-content: flex-end;
`;

export const ClickablePathItem = styled.div`
  cursor: pointer;
  font-weight: 600;
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;

export const NonClickablePathItem = styled.div`
  font-weight: 600;
`;
